 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import A780802188809 from '@/components/9780802188809'
 import LOVE_1 from '@/components/love_1'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import A7808021888091 from '@/components/9780802188809-1'
 import A7808021888092 from '@/components/9780802188809-2'
 import A7808021888093 from '@/components/9780802188809-3'
 import A7808021888094 from '@/components/9780802188809-4'
 import A7808021888095 from '@/components/9780802188809-5'
 import A7808021888096 from '@/components/9780802188809-6'
 import A7808021888097 from '@/components/9780802188809-7'
 import A7808021888098 from '@/components/9780802188809-8'
 import A7808021888099 from '@/components/9780802188809-9'
 import A78080218880910 from '@/components/9780802188809-10'
 import A78080218880911 from '@/components/9780802188809-11'
 import A78080218880912 from '@/components/9780802188809-12'
 import A78080218880913 from '@/components/9780802188809-13'
 import A78080218880914 from '@/components/9780802188809-14'
 import A78080218880915 from '@/components/9780802188809-15'
 import A78080218880916 from '@/components/9780802188809-16'
 import A78080218880917 from '@/components/9780802188809-17'
 import A78080218880918 from '@/components/9780802188809-18'
 import A78080218880919 from '@/components/9780802188809-19'
 import A78080218880920 from '@/components/9780802188809-20'
 import A78080218880921 from '@/components/9780802188809-21'
 import A78080218880922 from '@/components/9780802188809-22'
 import A78080218880923 from '@/components/9780802188809-23'
 import A78080218880924 from '@/components/9780802188809-24'
 import A78080218880925 from '@/components/9780802188809-25'
 import A78080218880926 from '@/components/9780802188809-26'
 import A78080218880927 from '@/components/9780802188809-27'
 import A78080218880928 from '@/components/9780802188809-28'
 import A78080218880929 from '@/components/9780802188809-29'
 import A78080218880930 from '@/components/9780802188809-30'
 import A78080218880931 from '@/components/9780802188809-31'
 import A78080218880932 from '@/components/9780802188809-32'
 import A78080218880933 from '@/components/9780802188809-33'
 import LOVE_2 from '@/components/love_2'
 import A78080218880934 from '@/components/9780802188809-34'
 import A78080218880935 from '@/components/9780802188809-35'
 import A78080218880936 from '@/components/9780802188809-36'
 import A78080218880937 from '@/components/9780802188809-37'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/9780802188809",
 			"name" : "9780802188809",
 			"component" : A780802188809
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/9780802188809-1",
 			"name" : "9780802188809-1",
 			"component" : A7808021888091
 		},
 		{
 			"path" : "/9780802188809-2",
 			"name" : "9780802188809-2",
 			"component" : A7808021888092
 		},
 		{
 			"path" : "/9780802188809-3",
 			"name" : "9780802188809-3",
 			"component" : A7808021888093
 		},
 		{
 			"path" : "/9780802188809-4",
 			"name" : "9780802188809-4",
 			"component" : A7808021888094
 		},
 		{
 			"path" : "/9780802188809-5",
 			"name" : "9780802188809-5",
 			"component" : A7808021888095
 		},
 		{
 			"path" : "/9780802188809-6",
 			"name" : "9780802188809-6",
 			"component" : A7808021888096
 		},
 		{
 			"path" : "/9780802188809-7",
 			"name" : "9780802188809-7",
 			"component" : A7808021888097
 		},
 		{
 			"path" : "/9780802188809-8",
 			"name" : "9780802188809-8",
 			"component" : A7808021888098
 		},
 		{
 			"path" : "/9780802188809-9",
 			"name" : "9780802188809-9",
 			"component" : A7808021888099
 		},
 		{
 			"path" : "/9780802188809-10",
 			"name" : "9780802188809-10",
 			"component" : A78080218880910
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js